<template>
  <div>
    <loading-spinner
      v-if="isLoading"
      custom-id="loading_spinner_send_test"
      :loading-status="isLoading"
    />
    <div :key="checkboxReload">
      <ejs-checkbox
        v-model="isLegal"
        label="This email address is in compliance with global spam laws: "
        css-class="my-3"
      />
      <a
        href="https://help.cendyn.com/hc/en-us/articles/360047315851-eInsight-Features-CASL"
        target="_blank"
        class="ml-3"
      >
        <font-awesome-icon
          :icon="['fas', 'question-circle']"
          class="question-circle-icon"
        />
      </a>
    </div>
    <div class="treeview-container">
      <div :class="['treeview-overlay', {active: !isLegal }]" />
      <div class="row">
        <div class="col-lg-6">
          <div class="e-input-group">
            <input
              id="inputFilter"
              v-model="filter"
              class="e-input"
              name="input"
              type="text"
              placeholder="Filter"
              autocomplete="off"
            >
          </div>
        </div>
      </div>
      <ejs-treeview
        id="treeview"
        ref="emailListTreeview"
        :fields="filteredFields"
        :show-check-box="true"
        :node-clicked="nodeChecked"
        :key-press="nodeChecked"
        :node-template="RowTemplate"
      />
    </div>
    <div class="d-flex justify-content-left py-4">
      <button
        id="btnCancel"
        class="btn btn-lg btn-outline-secondary px-4 white ml-3"
        @click="onCancel"
      >
        Cancel
      </button>
      <button
        id="btnSend"
        class="btn btn-lg btn-primary px-4 white ml-3"
        :disabled="!isLegal"
        @click="onSend"
      >
        Send
      </button>
    </div>
    <BaseDialog
      ref="manageTestEmailFormDialog"
      title="Manage a Test Email"
      :force-header="true"
      :custom-content-template="testEmailForm"
      :show-close-icon="true"
      :on-open="onOpenFormDialog"
      :on-close="onCloseFormDialog"
      width="400px"
      height="450px"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { TreeViewPlugin } from '@syncfusion/ej2-vue-navigations'
import LoadingSpinner from '@/components/LoadingSpinner'
import BaseDialog from '@/components/Dialog/BaseDialog'
import RowTemplate from './RowTemplate'
import TestEmailForm from './TestEmailForm'

Vue.use(TreeViewPlugin)

export default {
  components: {
    LoadingSpinner,
    BaseDialog
  },
  data () {
    return {
      checkboxReload: 0,
      isLegal: false,
      filter: '',
      testEmailForm: TestEmailForm,
      RowTemplate: function (e) {
        return {
          template: RowTemplate
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoadingStatus',
      emailTesting: 'getEmailTesting',
      emailList: 'getEmailTestingList',
      groups: 'getEmailTestingGroups'
    }),
    isDialogOpen () {
      return this.emailTesting.sendTestModalIsOpen
    },
    hasDialogClose () {
      return this.emailTesting.hasDialogClose
    },
    filteredFields () {
      let dataSource = []
      if (this.filter.length) {
        const searchTerm = this.filter.toLowerCase()
        dataSource = this.emailList.filter(item => {
          if (item.id in this.groups) {
            return true
          } else if (item.name.toLowerCase().includes(searchTerm)) {
            return true
          }
          return false
        })
      } else {
        dataSource = this.emailList
      }
      const groupsKeys = Object.keys(this.groups)
      const groupIndex = groupsKeys.findIndex(item => item.toLowerCase() === 'group')
      const tmp = groupsKeys.splice(groupIndex, 1)
      groupsKeys.push(tmp.pop())

      groupsKeys.forEach(group => {
        const byGroup = dataSource.filter(tmp => tmp.pid === group)
        const groupIndex = dataSource.findIndex(g => g.id === group)
        if (groupIndex > -1) {
          if (byGroup.length === 0) {
            dataSource.splice(groupIndex, 1)
          } else {
            dataSource[groupIndex].expanded = true
          }
        }
      })
      return {
        dataSource,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild'
      }
    }
  },
  watch: {
    hasDialogClose (newVal) {
      if (newVal === true) {
        let groups = Object.keys(this.groups)
        groups = groups.filter(group => group !== 'EmailToSelf')
        this.$refs.emailListTreeview.uncheckAll(groups)
        this.isLegal = false
        this.checkboxReload++
        this.$refs.emailListTreeview.checkAll(['EmailToSelf'])
      }
    }
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    // const templateId = this.$route.params.id
    this.getSeedList({ userEmail })

    this.$store.commit('SET_EMAIL_TESTING', {
      manageModalRef: this.$refs.manageTestEmailFormDialog
    })
  },
  methods: {
    ...mapActions([
      'getSeedList',
      'sendTest'
    ]),
    getRefs () {
      return this.$refs
    },
    nodeChecked (args) {
      const treeObj = document.getElementById('treeview').ej2_instances[0]
      const checkedNode = [args.node]
      const nodeDetails = treeObj.getNode(args.node)
      if (args.event.target.classList.contains('e-fullrow') || args.event.key === 'Enter') {
        if (nodeDetails.isChecked === 'true') {
          treeObj.uncheckAll(checkedNode)
          for (let i; i < this.filteredFields.dataSource; i++) {
            if (this.emailList[i].pid === nodeDetails.parentID) {
              this.emailList[i].isChecked = 'false'
            }
          }
        } else {
          treeObj.checkAll(checkedNode)
          for (let i; i < this.emailList; i++) {
            if (this.emailList[i].pid === nodeDetails.parentID) {
              this.emailList[i].isChecked = 'true'
            }
          }
        }
      } else if (nodeDetails.isChecked === 'true') {
        const i = this.emailList.findIndex(item => item.id === nodeDetails.id)
        if (i > -1) {
          this.emailList[i].isChecked = nodeDetails.isChecked
        }
      }
    },
    onSend () {
      const checkedItems = this.$refs.emailListTreeview.getAllCheckedNodes()
      let validItems = checkedItems.filter(item => (!(item in this.groups)))
      validItems = validItems.map(item => item.replace(/\[.*\]/, ''))
      if (validItems.length) {
        const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
        const templateId = this.$route.params.id || this.$route.query.templateId
        this.sendTest({
          userEmail,
          templateId,
          data: validItems
        }).then(({ success }) => {
          this.emailTesting.sendTestModalRef.closeDialog()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    onCancel () {
      this.emailTesting.sendTestModalRef.closeDialog()
    },
    onOpenFormDialog () {
      this.$store.commit('SET_SEND_EMAIL_TESTING_EDITING_MODAL_IS_OPEN', open)
    },
    onCloseFormDialog () {
      this.$store.commit('SET_EMAIL_TESTING_ON_EDITION', null)
      this.$store.commit('SET_SEND_EMAIL_TESTING_EDITING_MODAL_IS_OPEN', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .treeview {
    &-container {
      position: relative;
    }
    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $white;
      opacity: .8;
      z-index: 2;
      display: none;
      &.active {
        display: block;
      }
    }
  }
  .question-circle-icon {
    position: relative;
    top: 2px;
  }
</style>
